import { render } from "./Koffietafel.vue?vue&type=template&id=4c0e299c&scoped=true"
import script from "./Koffietafel.vue?vue&type=script&lang=js"
export * from "./Koffietafel.vue?vue&type=script&lang=js"

import "./Koffietafel.vue?vue&type=style&index=0&id=4c0e299c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c0e299c"]])

export default __exports__